/* eslint-disable @typescript-eslint/no-unused-vars */
/* Autogenerated, do not modify! */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import SvgIcon from '@move-ui/svg-icon';
export const ReloadIcon = (_a) => {
    var { fillColor = 'currentColor', strokeColor = 'currentColor' } = _a, svg = __rest(_a, ["fillColor", "strokeColor"]);
    return (React.createElement(SvgIcon, Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24", "data-icon": true }, svg),
        React.createElement("path", { fill: fillColor, fillRule: "evenodd", d: "M17.657 18.604A8.22 8.22 0 0020 12.818a8.22 8.22 0 00-2.343-5.785 7.913 7.913 0 00-3.524-2.101V3.818a0.82 0.82 0 00-0.43-0.725 0.784 0.784 0 00-0.828 0.055l-2.667 1.909a0.825 0.825 0 00-0.341 0.67 0.824 0.824 0 000.34 0.67l2.668 1.91a0.784 0.784 0 000.828 0.055 0.82 0.82 0 000.43-0.726V6.644a6.363 6.363 0 012.393 1.546 6.579 6.579 0 011.874 4.628 6.578 6.578 0 01-1.874 4.629A6.288 6.288 0 0112 19.364a6.289 6.289 0 01-4.526-1.917A6.579 6.579 0 015.6 12.818 6.58 6.58 0 017.474 8.19a0.831 0.831 0 000-1.157 0.787 0.787 0 00-1.13 0A8.221 8.221 0 004 12.818a8.221 8.221 0 002.343 5.786A7.858 7.858 0 0012 21a7.858 7.858 0 005.657-2.396z", clipRule: "evenodd" })));
};
//# sourceMappingURL=ReloadIcon.js.map